import styled from '@emotion/styled';

export const SystemStatusBtnWrapper = styled.div`
    cursor: pointer;
    margin-left: 8px;
    .system-status-icon {
        display: flex;
        vertical-align: middle;
        padding: 0 8px;
    }
    svg {
        width: 20px;
        height: 20px;
    }
`;
